
export default function() {
  const config = {
    baseURL: process.env.VUE_APP_URL,
    withCredentials: true,
    maxContentLength: 2000 * 1000000000
  };
  /* eslint-disable-next-line */
  const api = axios.create(config);
  // Torna a instancia do axios global
  /* eslint-disable-next-line */
  axios = api;

  api.interceptors.response.use(
    response => response,
    error => {
      if (401 === error.response.status) {
        // TODO: Erro no bot standalone ao executar iframe em HTML externo ao projeto
        // Cenário: O bot consegue autenticar corretamente, mas o cookie obtido nas chamadas seguintes continua 'null'
        // Hipótese: Chrome rejeita teste pois não armazena Cookies em HTML local? Nesse caso, por que o sistema sem iFrame funciona? (Referência: https://stackoverflow.com/a/6232366/11698426)
        try {window.reload(true)} catch { throw error};
      } else {
        throw error;
      }
    }
  );

  return api;
}
